<template>
  <div>
    <div class="main-header">
      <h1>{{ organization.businessName }}</h1>
      <div class="header-buttons">
        <!-- <button>
          <vs-icon icon="file_download"></vs-icon>
        </button> -->
        <button @click="emitEdit" class="secondary">
          Volver al listado
        </button>
      </div>
    </div>

    <div class="card tab-header">
      <vs-tabs class="we-tabs entity" ref="tabs">
        <vs-tab label="Datos de la entidad">
          <EntityAdminTab :organization="organization"></EntityAdminTab>
        </vs-tab>
        <vs-tab label="Datos del administrador">
          <AdminDataTab :organization="organization"></AdminDataTab>
        </vs-tab>
        <vs-tab label="Establecimientos">
          <Establishments @reload="$emit('reload')" :organization="organization"></Establishments>
        </vs-tab>
        <vs-tab label="Usuarios">
          <UsersAdminTab :organization="organization"></UsersAdminTab>
        </vs-tab>
        <vs-tab label="Habilitación">
          <OrganizationState :organization="organization"></OrganizationState>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'
import EntityAdminTab from './admin/EntityAdminTab'
import AdminDataTab from './admin/AdminDataTab'
import Establishments from './admin/EstablishmentsTab'
import UsersAdminTab from './admin/UsersAdminTab'
import Organizations from './admin/Organizations'
import OrganizationState from './admin/OrganizationState'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  name: 'organization-settings-backend',
  data () {
    return {
      
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    })
  },
  components: {
    Organizations,
    EntityAdminTab,
    AdminDataTab,
    Establishments,
    UsersAdminTab,
    OrganizationState
  },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  methods: {
    emitEdit() {
      this.$emit('updated-edit')
    }
  }

}

</script>
